import React, { useState, useMemo, useEffect } from "react";
import { useLocation } from 'react-router-dom'; // Import useLocation from React Router
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { MdOutlineFileUpload } from "react-icons/md";
import redirectURL from "../redirectURL"
import * as XLSX from "xlsx";
import Select from "react-select";
import InventoryPolicies from "./inventory-polacies";
import SupplierConfigurations from "./suplier-configurations";
import ReplenishmentLogicSettings from "./replishment-config";
import AlertsSettings from "./alert-configs";
import OrderGeneartion from "./inventory-ordergeneration";

import DarkstoreConfigurations from './darkstoreconfiguration.js';
import WarehouseConfigurations from './warehouseconfiguration.js';




const InventoryConfiguration = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");

  const [uploadedFileData, setUploadedFileData] = useState([]);
  const [currentUploadedDate, setCurrentUploadedDate] = useState("");

  const [skuCode, setSkuCode] = useState({ label: "ALL", value: "" });
  const [storeId, setStoreId] = useState({ label: "ALL", value: "" });

  const [showDeletePopup, setShowDeletePopup] = useState(false);

  // Tabs
  const tabs = [
    // { key: 'demand', label: 'Demand & Forecasting' },
    { key: "darkstoreConfiguration", label: "Darkstore Configuration" },
    { key: "warehouseConfiguration", label: "Warehouse Configuration" },

    // { key: 'inventory', label: 'Inventory Policies' },
    // { key: 'supplier', label: 'Supplier / Plant' },
    // { key: 'replenishment', label: 'Replenishment Logic' },
    { key: 'alerts', label: 'Alerts & Thresholds' },
    { key: "orderGeneration", label: "Order Management" },

    // { key: 'ui', label: 'UI / Functional' },
  ];

  const location = useLocation();

  // Reset the activeTab to default ('inventory') when the route changes
  useEffect(() => {
    localStorage.setItem('activeTab', "darkstoreConfiguration")
  }, [location]); // Dependency on location ensures it runs when the route changes
  const [activeTab, setActiveTab] = useState(localStorage.getItem('activeTab') || 'darkstoreConfiguration');

  // const renderTabContent = () => {
  //   switch (activeTab) {
  //     case 'demand':
  //       return <div>Demand & Forecasting Configuration Content</div>;
  //     case 'inventory':
  //       return <div>Inventory Policies Configuration Content</div>;
  //     case 'supplier':
  //       return <div>Supplier / Plant Configuration Content</div>;
  //     case 'replenishment':
  //       return <div>Replenishment Logic Configuration Content</div>;
  //     case 'alerts':
  //       return <div>Alerts & Thresholds Configuration Content</div>;
  //     case 'ui':
  //       return <div>UI / Functional Configuration Content</div>;
  //     default:
  //       return null;
  //   }
  // };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'inventory':
        return <InventoryPolicies />
      case 'supplier':
        return <SupplierConfigurations />
      case 'replenishment':
        return <ReplenishmentLogicSettings />
      case 'alerts':
        return <AlertsSettings />
      case "orderGeneration":
        return <OrderGeneartion />
      case "darkstoreConfiguration":
        return <DarkstoreConfigurations />
      case "warehouseConfiguration":
        return <WarehouseConfigurations />
      default:
        return null;
    }
  };



  const closeAlert = () => {
    const fileInput = document.getElementById("bulkUploadFile");
    if (fileInput !== null) {
      fileInput.value = "";
    }
    setUploadedFileData([]);
    setShow(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
    setShowDeletePopup(false);
    setCurrentUploadedDate("");
  };

  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    setCurrentUploadedDate("");
    setUploadedFileData([]);
  };

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
          <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={closeAlert}
            style={{ fontSize: "9px" }}
          />
        </div>

        <div className="row" style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}>
          <div className="col-sm-12 p-0 m-0 mb-4 row">
            <h1 className="col-sm-5" style={{
              color: "#B9366D", fontSize: "18px", fontWeight: "bold",
              fontFamily: "sans-serif"
            }}>System Configurations
            </h1>
            {/* <div className="col-sm-7" style={{textAlign: "right", display : "flex", justifyContent: "flex-end"}}>
              <button  
              className="col-sm-3"

                      onClick={() => {
                        // console.log("Saving thresholds:", thresholds);
                        // console.log("Saving alert toggles:", alertToggles);
                        alert("Configurations saved successfully!");
                      }}
                      style={{
                        
                        padding: "10px 20px",
                        backgroundColor: "#991548",
                        color: "white",
                        border: "none",
                        borderRadius: 8,
                        fontSize: 14,
                        cursor: "pointer",
                      }}
                    >
                      Save All Configurations
                    </button>
            </div> */}
          </div>

          <div className="col-sm-12 p-0 m-0 pr-2 p-2" style={{ minHeight: "60vh", background: "#fff" }}>
            <div className="col-md-12 ">
              <h1 style={{ color: "#020817", fontSize: "20px" }}>Configuration Sections</h1>
              <p style={{ fontSize: "13px", color: "#78889A" }}>
                Configure all aspects of your supply chain replenishment system
              </p>

              <div className="tab-section mb-2" style={{
                display: 'flex',
                gap: '20px',
                borderBottom: '1px solid #eee',
                marginTop: '10px',
                overflowX: 'auto',
              }}>
                {tabs.map(tab => (
                  <button
                    key={tab.key}
                    onClick={() => setActiveTab(tab.key)}
                    style={{
                      padding: '8px 12px',
                      border: 'none',
                      background: activeTab === tab.key ? '#fff' : '#f9f9f9',
                      borderBottom: activeTab === tab.key ? '2px solid #B9366D' : 'none',
                      color: activeTab === tab.key ? '#000' : '#666',
                      fontWeight: activeTab === tab.key ? 'bold' : 'normal',
                      cursor: 'pointer',
                      fontSize: '13px',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>

              <div style={{ padding: '20px 0' }}>
                {/* Save All Configurations Button */}


                {renderTabContent()}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Overlays */}
      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
<div style={{ zIndex: 997 }} className={`overlay-block ${overlayBlock}`}></div>
      <div className={"overly-block " + overlyBlock} onClick={hideOverlySlideBlock}></div>
    </>
  );
};

export default InventoryConfiguration;
